import React, { FC } from 'react';
import MailSingleLayout, { MailSingleProps } from './layout';

import {
	usePlanOptionLocalizationHelper,
	PlanOptionIntervalHelper,
} from '../helpers/planOptionHelper';
import { useT } from '@hooks';

export enum MAIL_SINGLE_VERSION {
	V0 = 'mailSingleV0',
	V1 = 'mailSingleV1',
	V2 = 'mailSingleV2',
	V3 = 'mailSingleV3',
	V4 = 'mailSingleV4',
}

interface MailSingleBlockProps {
	version: MAIL_SINGLE_VERSION;
}

const MailSingleBlock: FC<MailSingleBlockProps> = props => {
	const { version: interval } = props;
	const { T } = useT();
	const localizator = usePlanOptionLocalizationHelper();

	switch (interval) {
		case MAIL_SINGLE_VERSION.V2: {
			const config: MailSingleProps = {
				productID: 'verv_1MONTH_9_99',
				defaults: {
					daysInterval: PlanOptionIntervalHelper.monthDaysInterval,
					price: 9.99,
				},
				localizations: {
					...localizator.monthOptionLocalizations,
					title: T('tariff_title_get'),
				},
			};
			return <MailSingleLayout {...config} />;
		}
		case MAIL_SINGLE_VERSION.V1: {
			const config: MailSingleProps = {
				productID: 'verv_3MONTH_14_99',
				defaults: {
					daysInterval: PlanOptionIntervalHelper.threeMonthsDaysInterval,
					price: 14.99,
				},
				localizations: {
					...localizator.threeMonthOptionLocalizations,
					title: T('tariff_title_get'),
				},
			};
			return <MailSingleLayout {...config} />;
		}
		case MAIL_SINGLE_VERSION.V0: {
			const config: MailSingleProps = {
				productID: 'verv_6MONTH_29_99',
				defaults: {
					daysInterval: PlanOptionIntervalHelper.sixMonthsDayInterval,
					price: 29.99,
				},
				localizations: {
					...localizator.sixMonthOptionLocalizations,
					title: T('tariff_title_get'),
				},
			};
			return <MailSingleLayout {...config} />;
		}
		case MAIL_SINGLE_VERSION.V3: {
			const config: MailSingleProps = {
				productID: 'verv_1YEAR_49_99',
				defaults: {
					daysInterval: PlanOptionIntervalHelper.yearDayInterval,
					price: 49.99,
				},
				localizations: {
					...localizator.yearOptionLocalizations,
					title: T('tariff_title_get'),
				},
			};
			return <MailSingleLayout {...config} />;
		}
		case MAIL_SINGLE_VERSION.V4: {
			const config: MailSingleProps = {
				productID: 'verv_3MONTH_14_99',
				defaults: {
					daysInterval: PlanOptionIntervalHelper.threeMonthsDaysInterval,
					price: 14.99,
				},
				localizations: {
					...localizator.threeMonthOptionLocalizations,
					title: T('tariff_title_get'),
				},
			};
			return <MailSingleLayout {...config} />;
		}
		default: {
			const config: MailSingleProps = {
				productID: 'verv_1YEAR_49_99',
				defaults: {
					daysInterval: PlanOptionIntervalHelper.yearDayInterval,
					price: 49.99,
				},
				localizations: {
					...localizator.yearOptionLocalizations,
					title: T('tariff_title_get'),
				},
			};
			return <MailSingleLayout {...config} />;
		}
	}
};
export default MailSingleBlock;
